/**
 * Met en forme un numéro de téléphone français pour l'affichage, par paires de chiffres :
 * `+33617507937` → `+33 6 17 50 79 37`, `0617507937` → `06 17 50 79 37`.
 *
 * Les numéros arrivent sans format imposé : celui des représentants vient de Tolede, celui de la
 * société commerciale est saisi librement au back-office. Les espaces, points et tirets sont
 * ignorés ; tout ce qui n'est pas un numéro français à 10 chiffres est renvoyé tel quel.
 * À n'utiliser que pour l'affichage : un lien `tel:` garde la valeur d'origine.
 */
export const formaterTelephone = (
  telephone: string | undefined,
): string | undefined => {
  if (!telephone) {
    return telephone;
  }

  const compact = telephone.replace(/[\s.-]/g, '');
  if (!/^(\+33|0)[1-9]\d{8}$/.test(compact)) {
    return telephone;
  }

  // Préfixe (`+33` ou `0`), premier chiffre, puis les 8 derniers chiffres par paires
  const prefixe = compact.slice(0, -9);
  const premierChiffre = compact.slice(-9, -8);
  const paires = compact.slice(-8).replace(/(\d{2})(?=\d)/g, '$1 ');

  return prefixe === '0'
    ? `0${premierChiffre} ${paires}`
    : `+33 ${premierChiffre} ${paires}`;
};
